import React, { useState } from 'react'
import { Button, Input, Table } from 'reactstrap'
import Breadcrumb from '../../components/Common/Breadcrumb'
import Select from '../../components/Template/Input/Select'
import MaskedInput from '../../components/Template/Input/MaskedInput'
import DataTable from '../../components/Template/Table/DataTable'
import FormInputTooltip from '../../components/Template/Tooltip/FormInputTooltip'
import StepStatus from '../../components/Template/Progress/StepStatus'
import ModalConfirmacao from '../../components/Modals/ModalConfirmacao/ModalConfirmacao'
import Legenda from '../../components/Legenda/Legenda'

/**
 * Preview só de layout/aparência para catálogo e padronização.
 * Não executa fluxo de negócio nem API dos componentes pesados.
 */

const SELECT_OPTS = [
  { value: 'a', label: 'Opção A' },
  { value: 'b', label: 'Opção B' },
]

const SAMPLE_DT = {
  columns: [
    { label: 'Coluna', field: 'c', sort: 'asc' },
    { label: 'Valor', field: 'v', sort: 'asc' },
  ],
  rows: [
    { c: 'Exemplo 1', v: '—' },
    { c: 'Exemplo 2', v: '—' },
  ],
}

function PreviewModal({ title }) {
  return (
    <div className="ui-pg-layout ui-pg-layout--modal" aria-hidden>
      <div className="ui-pg-layout-modal">
        <div className="ui-pg-layout-modal__bar">
          <strong>{title}</strong>
          <span aria-hidden>×</span>
        </div>
        <div className="ui-pg-layout-modal__body">
          <label className="ui-pg-layout-label">Campo</label>
          <div className="ui-pg-layout-field" />
          <label className="ui-pg-layout-label">Campo</label>
          <div className="ui-pg-layout-field ui-pg-layout-field--short" />
          <div className="ui-pg-layout-field ui-pg-layout-field--area" />
        </div>
        <div className="ui-pg-layout-modal__foot">
          <span className="ui-pg-layout-btn">Cancelar</span>
          <span className="ui-pg-layout-btn ui-pg-layout-btn--primary">Salvar</span>
        </div>
      </div>
    </div>
  )
}

function PreviewTable({ title }) {
  return (
    <div className="ui-pg-layout ui-pg-layout--table">
      <div className="ui-pg-layout-table-caption">{title}</div>
      <Table size="sm" bordered className="mb-0 ui-pg-layout-table">
        <thead>
          <tr>
            <th>Col A</th>
            <th>Col B</th>
            <th>Col C</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>linha</td>
            <td>—</td>
            <td>—</td>
            <td className="text-right text-muted">⋯</td>
          </tr>
          <tr>
            <td>linha</td>
            <td>—</td>
            <td>—</td>
            <td className="text-right text-muted">⋯</td>
          </tr>
        </tbody>
      </Table>
    </div>
  )
}

function PreviewForm({ title }) {
  return (
    <div className="ui-pg-layout ui-pg-layout--form">
      <div className="ui-pg-layout-form-title">{title}</div>
      <div className="ui-pg-layout-form-row">
        <label>Label</label>
        <Input disabled placeholder="input / select / máscara" />
      </div>
      <div className="ui-pg-layout-form-row">
        <label>Label</label>
        <Input disabled placeholder="…" />
      </div>
    </div>
  )
}

function PreviewShell({ title }) {
  return (
    <div className="ui-pg-layout ui-pg-layout--shell">
      <div className="ui-pg-layout-chrome__top">{title || 'Header'}</div>
      <div className="ui-pg-layout-chrome__nav">Navbar · item · item</div>
      <div className="ui-pg-layout-chrome__main">conteúdo da rota</div>
    </div>
  )
}

function PreviewUtil({ title }) {
  return (
    <div className="ui-pg-layout ui-pg-layout--util">
      <code>{title}</code>
      <span>utilitário / hook — sem UI própria (só contrato de funções)</span>
    </div>
  )
}

function PreviewStatus({ title }) {
  return (
    <div className="ui-pg-layout ui-pg-layout--status">
      <div className="ui-pg-layout-status-title">{title}</div>
      <div className="ui-pg-layout-steps">
        {['A', 'B', 'C', 'D'].map((label, i) => (
          <React.Fragment key={label}>
            {i > 0 && <span className={`ui-pg-layout-line${i <= 2 ? ' is-on' : ''}`} />}
            <span className={`ui-pg-layout-dot${i < 2 ? ' is-done' : ''}${i === 2 ? ' is-now' : ''}`} />
          </React.Fragment>
        ))}
      </div>
      <div className="ui-pg-layout-step-labels">
        <span>Etapa</span>
        <span>Etapa</span>
        <span>Atual</span>
        <span>Próx.</span>
      </div>
    </div>
  )
}

function PreviewChart({ title }) {
  return (
    <div className="ui-pg-layout ui-pg-layout--chart">
      <div className="ui-pg-layout-chart-title">{title}</div>
      <div className="ui-pg-layout-bars">
        <span style={{ height: '40%' }} />
        <span style={{ height: '70%' }} />
        <span style={{ height: '55%' }} />
        <span style={{ height: '85%' }} />
        <span style={{ height: '45%' }} />
      </div>
    </div>
  )
}

/** Poucos padrões reais do design system — só aparência, sem negócio. */
function RealPatternPreview({ codigo }) {
  const [sel, setSel] = useState(SELECT_OPTS[0])
  const [open, setOpen] = useState(false)

  switch (codigo) {
    case 'CMP-006':
      return (
        <Breadcrumb
          title="Título da página"
          breadcrumbItems={[
            { title: 'Início', link: '/dashboard' },
            { title: 'Seção', link: '#' },
            { title: 'Atual' },
          ]}
        />
      )
    case 'CMP-014':
      return (
        <div style={{ maxWidth: 220 }}>
          <label className="ui-pg-layout-label">Máscara (CPF)</label>
          <MaskedInput mask="000.000.000-00" placeholder="000.000.000-00" />
        </div>
      )
    case 'CMP-015':
      return (
        <div style={{ maxWidth: 260 }}>
          <label className="ui-pg-layout-label">Select</label>
          <Select options={SELECT_OPTS} value={sel} onChange={setSel} />
        </div>
      )
    case 'CMP-017':
      return <DataTable data={SAMPLE_DT} entries={3} paging={false} searching={false} />
    case 'CMP-039':
      return <StepStatus actual={3} />
    case 'CMP-043':
      return (
        <div className="d-flex align-items-center">
          <span>Label do campo</span>
          <FormInputTooltip text="Ajuda contextual (tooltip)" />
        </div>
      )
    case 'CMP-044':
      return (
        <>
          <Button color="primary" size="sm" onClick={() => setOpen(true)}>
            Ver layout do modal
          </Button>
          <ModalConfirmacao
            openModal={open}
            title="Título"
            subtitle="Subtítulo"
            text="Corpo do modal — só layout de confirmação."
            onClosed={() => setOpen(false)}
            onConfirm={() => setOpen(false)}
            confirmButtonText="Confirmar"
          />
        </>
      )
    case 'CMP-111':
      return (
        <Legenda objLegenda={{ Ativo: '#339933', Pendente: '#f0ad4e', Critico: '#dc3545' }} />
      )
    default:
      return null
  }
}

const REAL_PATTERN_CODES = new Set([
  'CMP-006', 'CMP-014', 'CMP-015', 'CMP-017', 'CMP-039', 'CMP-043', 'CMP-044', 'CMP-111',
])

function resolvePreviewKind(item) {
  const { grupoId, nome, arquivo, kind } = item
  const n = `${nome} ${arquivo}`

  if (kind === 'util' || /Utils|utils|Placeholders|Texts|Fields|Data|use[A-Z]/.test(nome)) {
    if (nome[0] === nome[0].toLowerCase() || nome.startsWith('use') || /Utils|Info$|Texts|Placeholders|Fields|Data|Submit/.test(nome)) {
      return 'util'
    }
  }
  if (grupoId === 'layout' || kind === 'shell') return 'shell'
  if (grupoId === 'modals-novos' || grupoId === 'modal-legado' || /Modal/.test(nome)) return 'modal'
  if (grupoId === 'template-table' || /Table|Grid|Extrato|List|Pqgrid|DBTable|MaterialTable|Tabela/.test(n)) return 'table'
  if (grupoId === 'template-input' || grupoId === 'template-files' || /Select|Input|Switch|Files|Tooltip/.test(n)) return 'form'
  if (grupoId === 'produto-status' || /Step|Timeline|Status|CardInfo/.test(n)) return 'status'
  if (grupoId === 'graficos' || /Chart|Gantt|Temporal|Calendar/.test(n)) return 'chart'
  if (grupoId === 'common') return 'form'
  if (kind === 'morto') return 'util'
  return 'form'
}

export function previewKindLabel(kind) {
  return ({
    modal: 'layout modal',
    table: 'layout tabela',
    form: 'layout formulário',
    shell: 'layout chrome',
    util: 'sem UI',
    status: 'layout status',
    chart: 'layout gráfico',
    pattern: 'padrão real',
  })[kind] || kind
}

export default function LayoutPreview({ item }) {
  if (REAL_PATTERN_CODES.has(item.codigo)) {
    return (
      <div className="ui-pg-layout-wrap">
        <RealPatternPreview codigo={item.codigo} />
        <p className="ui-pg-layout-note">
          Padrão visual real do design system (sem fluxo de negócio).
        </p>
      </div>
    )
  }

  const kind = resolvePreviewKind(item)
  let preview = null
  if (kind === 'modal') preview = <PreviewModal title={item.nome} />
  else if (kind === 'table') preview = <PreviewTable title={item.nome} />
  else if (kind === 'shell') preview = <PreviewShell title={item.nome} />
  else if (kind === 'util') preview = <PreviewUtil title={item.nome} />
  else if (kind === 'status') preview = <PreviewStatus title={item.nome} />
  else if (kind === 'chart') preview = <PreviewChart title={item.nome} />
  else preview = <PreviewForm title={item.nome} />

  return (
    <div className="ui-pg-layout-wrap" data-preview={kind}>
      {preview}
      <p className="ui-pg-layout-note">
        Preview de layout para padronização — não é o componente ligado à API.
      </p>
    </div>
  )
}

export { resolvePreviewKind, REAL_PATTERN_CODES }
